// extracted by mini-css-extract-plugin
module.exports = {"entry":"entry___1Eigc"};